const data = {
    table: {
        columns: [
            {title: '项目代码', field: 'code', width: '140'},
            {title: '项目名称', field: 'name', width: ''},
            {title: '费用金额', field: 'fee', width: '180'},
            {title: '备注', field: 'remarks', width: ''}
        ],
        data: [],
        total: 0,
        page: 1,
        pageSize: 20
    }
}

export default data
